import firestore from '@/firebase'

function batchAddNotifications(notifications) {
  const batch = firestore.batch()
  const batchedNotifications = []
  for (const notification of notifications) {
    const docRef = firestore.collection('Notifications').doc()
    batch.set(docRef, notification)
    batchedNotifications.push({ ...notification, id: docRef.id })
  }
  return batch.commit().then(() => batchedNotifications)
}

export default {
  state: {
    notifications: []
  },
  getters: {
    notifications: state => state.notifications
  },
  mutations: {
    setNotifications(state, notifications) {
      state.notifications = notifications
    },
    addNotification(state, notification) {
      state.notifications.push(notification)
      return notification
    },
    addNotifications(state, notifications) {
      state.notifications = [...state.notifications, ...notifications]
    },
    deleteNotifications(state, notifications) {
      for (const { id } of notifications) {
        const idx = state.notifications.findIndex(c => c.id === id)
        state.notifications.splice(idx, 1)
      }
    }
  },

  actions: {
    addNotification({ commit }, notification) {
      return firestore
        .collection('Notifications')
        .add(notification)
        .then(doc => doc.get())
        .then(notifiation => {
          return commit('addNotification', {
            id: notifiation.id,
            ...notifiation.data()
          })
        })
    },
    addNotifications({ commit }, notifications) {
      return batchAddNotifications(notifications)
      //.then(notifications => {
      // commit('addNotifications', notifications)
      //})
    },
    getNotifications({ commit, rootState }) {
      if (rootState && rootState.user) {
        const userId = rootState.user.user.id
        return firestore
          .collection('Notifications')
          .where('userId', '==', userId)
          .get()
          .then(snapshot => {
            const notifications = snapshot.docs.map(doc => ({
              ...doc.data(),
              id: doc.id
            }))
            commit('setNotifications', notifications)
          })
      }
    },
    getSharedNotifications({ rootState }, userIds) {
      return firestore
        .collection('Notifications')
        .where('userId', 'in', userIds)
        .where('type', '==', 'ShareLog')
        .get()
        .then(snapshot => {
          return snapshot.docs.map(doc => ({
            ...doc.data(),
            id: doc.id
          }))
        })
    },
    deleteNotifications({ commit }, notifications) {
      const batch = firestore.batch()
      for (const { id } of notifications) {
        const docRef = firestore.collection('Notifications').doc(id)
        batch.delete(docRef)
      }
      return batch.commit().then(() => {
        commit('deleteNotifications', notifications)
      })
    }
  }
}
